const id = 'txLog'

export default id
